import React from 'react';
import Icon from 'react-native-vector-icons/Feather';
import withPress from 'src/hoc/withPress';
import withDefaultIconProps from './withDefaultIconProps';
import withNotificationCount from './withNotificationCount';
const FeatherIcon = props => {
    return React.createElement(Icon, { ...props });
};
export default withDefaultIconProps(withPress(withNotificationCount(FeatherIcon)));
